import { configureStore } from '@reduxjs/toolkit'
import headerSlice from '../features/common/headerSlice.js'
import modalSlice from '../features/common/modalSlice.js'
import rightDrawerSlice from '../features/common/rightDrawerSlice.js'
import loginSlice from '../features/user/loginSlice.js'


const combinedReducer = {
  header: headerSlice,
  rightDrawer: rightDrawerSlice,
  modal: modalSlice,
  login: loginSlice
}

export default configureStore({
  reducer: combinedReducer
})